import React from 'react';
import styled, { keyframes } from 'styled-components';

const bubbleEffect = keyframes`
    0%{
    	transform: translateY(0);
      -webkit-transform: translateY(0);
    }
    100%{
      transform: translateY(-1080px) rotate(630deg);
      -webkit-transform: translateY(-1080px) rotate(630deg);
    }  
`;

const BubblesList = styled.ul`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  margin: 0;
  padding: 0;
  height: 100%;
  transform: translateZ(0);
  overflow-x: hidden;
`;

const Bubble = styled.li`
  position: absolute;
  list-style: none;
  border-radius: 50%;
  background-color: rgb(255, 255, 255);
  opacity: 0.2;
  bottom: 0;
  animation: ${bubbleEffect} 15s infinite;
  transition-timing-function: linear;
  &:nth-child(${props => props.child}) {
    left: ${props => props.position}%;
    animation-delay: ${props => props.delay}s;
    animation-duration: ${props => props.duration}s;
  }

  &:nth-child(even) {
    width: 20px;
    height: 20px;
  }
  &:nth-child(odd) {
    width: 40px;
    height: 40px;
  }
`;

function Bubbles() {
  const handlePosition = () => {
    return Math.floor(Math.random() * 100) + 1;
  };

  const handleDelay = () => {
    return Math.floor(Math.random() * 0) + 0;
  };

  const handleDuration = () => {
    return Math.floor(Math.random() * 17) + 5;
  };

  const bubbles = [...Array(50).keys()].map(x => x + 1);

  return (
    <BubblesList>
      {bubbles.map(bubble => (
        <Bubble
          key={bubble}
          child={bubble}
          position={() => handlePosition()}
          delay={() => handleDelay()}
          duration={() => handleDuration()}
        />
      ))}
    </BubblesList>
  );
}

export default Bubbles;
